import { useState, useEffect, useCallback, useRef } from 'react';

interface ToastState {
  message: string;
  visible: boolean;
}

export function useToast() {
  const [toast, setToast] = useState<ToastState>({ message: '', visible: false });
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Clear any pending timer to avoid setState-after-unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const showToast = useCallback((message: string, duration = 2000) => {
    // Clear any existing timer
    if (timerRef.current) clearTimeout(timerRef.current);

    setToast({ message, visible: true });

    timerRef.current = setTimeout(() => {
      setToast(prev => ({ ...prev, visible: false }));
      timerRef.current = null;
    }, duration);
  }, []);

  return { toast, showToast };
}
